import { render, staticRenderFns } from "./sgheader.vue?vue&type=template&id=1534d478&scoped=true"
import script from "./sgheader.vue?vue&type=script&lang=js"
export * from "./sgheader.vue?vue&type=script&lang=js"
import style0 from "./sgheader.vue?vue&type=style&index=0&id=1534d478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1534d478",
  null
  
)

export default component.exports